import React from "react";

// Renders plain text with any URLs (http/https or www.) as clickable links.
// Preserves line breaks via `whitespace-pre-wrap` on the wrapper.
const URL_RE = /((?:https?:\/\/|www\.)[^\s<]+[^\s<.,:;"')\]}])/gi;

export function Linkify({ text, className = "", linkClassName = "underline break-words" }) {
  const str = String(text || "");
  const parts = str.split(URL_RE);
  return (
    <span className={`whitespace-pre-wrap ${className}`}>
      {parts.map((part, i) => {
        if (i % 2 === 1) {
          const href = part.startsWith("http") ? part : `https://${part}`;
          return (
            <a key={i} href={href} target="_blank" rel="noopener noreferrer"
              className={linkClassName} onClick={(e) => e.stopPropagation()} data-testid="instruction-link">
              {part}
            </a>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
